import {Component, OnInit, Injectable} from '@angular/core';

import {config} from '../smartadmin.config';
import {Observable, Subject, Subscription} from 'rxjs/Rx';

import 'rxjs/add/operator/debounceTime';
import {NotificationService} from '../utils/notification.service';

import { Resources } from '../../app.service';

declare var $: any;

const store = {
  smartSkin: localStorage.getItem('sm-skin') || config.smartSkin,
  skin: config.skins.find((_skin) => {
    return _skin.name === (localStorage.getItem('sm-skin') || config.smartSkin)
  }),
  skins: config.skins,
  fixedHeader: localStorage.getItem('sm-fixed-header') === 'true',
  fixedNavigation: localStorage.getItem('sm-fixed-navigation') === 'true',
  fixedRibbon: localStorage.getItem('sm-fixed-ribbon') === 'true',
  fixedPageFooter: localStorage.getItem('sm-fixed-page-footer') === 'true',
  insideContainer: localStorage.getItem('sm-inside-container') === 'true',
  rtl: localStorage.getItem('sm-rtl') === 'true',
  menuOnTop: localStorage.getItem('sm-menu-on-top') === 'true',
  colorblindFriendly: localStorage.getItem('sm-colorblind-friendly') === 'true',

  shortcutOpen: false,
  isMobile: 	(/iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase())),
  device: '',

  mobileViewActivated: false,
  menuCollapsed: false,
  menuMinified: false,
};


@Injectable()
export class LayoutService {
  isActivated: boolean;
  smartSkin: string;

  store: any;
  asideWidth: number;

  private subject: Subject<any>;

  trigger(eventName:string = '') {
    this.processBody(this.store, eventName);
    this.subject.next(this.store)
  }

  subscribe(next, err?, complete?) {
    return this.subject.subscribe(next, err, complete)
  }

  constructor(private notificationService: NotificationService) {
    this.subject = new Subject();
    this.store = store;
    this.trigger();

    Observable.fromEvent(window, 'resize').debounceTime(100).map(() => {
      this.trigger()
    }).subscribe()
  }

  onSmartSkin(skin) {
    this.store.skin = skin;
    this.store.smartSkin = skin.name;
    this.dumpStorage();
    this.trigger();
  }

  onFixedHeader() {
    // this.store.fixedHeader = !this.store.fixedHeader; // www
    if (this.store.fixedHeader === false) {
      this.store.fixedRibbon = false;
      this.store.fixedNavigation = false;
    }
    this.dumpStorage();
    this.trigger()
  }


  onFixedNavigation() {
    // this.store.fixedNavigation = !this.store.fixedNavigation; // www

    if (this.store.fixedNavigation) {
      this.store.insideContainer = false;
      this.store.fixedHeader = true;
    } else {
      this.store.fixedRibbon = false;
    }
    this.dumpStorage();
    this.trigger()
  }

  onFixedRibbon() {
    // this.store.fixedRibbon = !this.store.fixedRibbon; // www
    if (this.store.fixedRibbon) {
      this.store.fixedHeader = true;
      this.store.fixedNavigation = true;
      this.store.insideContainer = false;
    }
    this.dumpStorage();
    this.trigger();
  }

  onFixedPageFooter() {
    // this.store.fixedPageFooter = !this.store.fixedPageFooter; // www
    this.dumpStorage();
    this.trigger()
  }

  onInsideContainer() {
    // this.store.insideContainer = !this.store.insideContainer; // www
    if (this.store.insideContainer) {
      this.store.fixedRibbon = false;
      this.store.fixedNavigation = false;
    }
    this.dumpStorage();
    this.trigger()
  }

  onRtl() {
    // this.store.rtl = !this.store.rtl; // www
    this.dumpStorage();
    this.trigger()
  }

  onMenuOnTop() {
    // this.store.menuOnTop = !this.store.menuOnTop; // www
    this.dumpStorage();
    this.trigger()
  }

  onColorblindFriendly() {
    // this.store.colorblindFriendly = !this.store.colorblindFriendly; // www
    this.dumpStorage();
    this.trigger()
  }

  onCollapseMenu(value?) {
    if (typeof value !== 'undefined') {
      this.store.menuCollapsed = value
    } else {
      this.store.menuCollapsed = !this.store.menuCollapsed;
    }

    this.trigger('onCollapseMenu');
  }

  onMinifyMenu() {
    this.store.menuMinified = !this.store.menuMinified;
    this.trigger('onMinifyMenu');
  }

  onShortcutToggle(condition?: any) {
    if (condition == null) {
      this.store.shortcutOpen = !this.store.shortcutOpen;
    } else {
      this.store.shortcutOpen = !!condition;
    }

    this.trigger();
  }

  dumpStorage() {
    localStorage.setItem('sm-skin', this.store.smartSkin);
    localStorage.setItem('sm-fixed-header', this.store.fixedHeader);
    localStorage.setItem('sm-fixed-navigation', this.store.fixedNavigation);
    localStorage.setItem('sm-fixed-ribbon', this.store.fixedRibbon);
    localStorage.setItem('sm-fixed-page-footer', this.store.fixedPageFooter);
    localStorage.setItem('sm-inside-container', this.store.insideContainer);
    localStorage.setItem('sm-rtl', this.store.rtl);
    localStorage.setItem('sm-menu-on-top', this.store.menuOnTop);
    localStorage.setItem('sm-colorblind-friendly', this.store.colorblindFriendly);
  }

  factoryReset() {
    this.notificationService.smartMessageBox({
      //title: '<i class="fa fa-refresh" style="color:green"></i> Clear Local Storage',
      //content: 'Would you like to RESET all your saved widgets and clear LocalStorage?',
      //buttons: '[No][Yes]'
      title: '<i class="fa fa-refresh" style="color:green"></i> ' + Resources.getLabel('menu.cacheRefresh'),
      content: Resources.getMessage('main.cacheRefresh.ask'),
      buttons : '[' + Resources.getLabel('Cancel') + '][OK]'
    }, (ButtonPressed) => {
      if (ButtonPressed === 'OK' && localStorage) {
        localStorage.clear();
        location.reload()
      }
    });
  }

  processBody(state, eventName:string = '') {
    let $body = $('body');
    $body.removeClass(state.skins.map((it) => (it.name)).join(' '));
    $body.addClass(state.skin.name);
    $('#logo img').attr('src', state.skin.logo);

    $body.toggleClass('fixed-header', state.fixedHeader);
    $body.toggleClass('fixed-navigation', state.fixedNavigation);
    $body.toggleClass('fixed-ribbon', state.fixedRibbon);
    $body.toggleClass('fixed-page-footer', state.fixedPageFooter);
    $body.toggleClass('container', state.insideContainer);
    $body.toggleClass('smart-rtl', state.rtl);
    $body.toggleClass('menu-on-top', state.menuOnTop);
    $body.toggleClass('colorblind-friendly', state.colorblindFriendly);
    $body.toggleClass('shortcut-on', state.shortcutOpen);

    state.mobileViewActivated = $(window).width() < 979;
    $body.toggleClass('mobile-view-activated', state.mobileViewActivated);
    if (state.mobileViewActivated) {
      $body.removeClass('minified');
    }

    if (state.isMobile) {
      $body.addClass('mobile-detected');
    } else {
      $body.addClass('desktop-detected');
    }

    if (state.menuOnTop) {
      $body.removeClass('minified');
    }

    if (!state.menuOnTop) {
      $body.toggleClass('hidden-menu-mobile-lock', state.menuCollapsed);
      $body.toggleClass('hidden-menu', state.menuCollapsed);
      $body.removeClass('minified');
    } else if (state.menuOnTop && state.mobileViewActivated) {
      $body.toggleClass('hidden-menu-mobile-lock', state.menuCollapsed);
      $body.toggleClass('hidden-menu', state.menuCollapsed);
      $body.removeClass('minified');
    }
    
    if (eventName === 'onCollapseMenu' || state.mobileViewActivated) {
      $('aside').css('width', '');
      $('#main').css('margin-left', '');
      $('#main').css('left', '');
      $('#ribbon').css('left', '');
    }

    if(state.mobileViewActivated){
      let hiddenMenu = $body.hasClass('hidden-menu');
      let winWidth = $(window).width();
      $('aside').children('nav').children('ul').css('cssText', '');
      if (hiddenMenu && winWidth < 640) {
        let asideWidth = winWidth - 50;
        $('aside').css('width', asideWidth);
        $('#main').css('left', asideWidth);
        $('#ribbon').css('left', asideWidth);
        $('aside').children('nav').children('ul').css('width', asideWidth);
      }
    }

    if (!state.mobileViewActivated && eventName === 'onCollapseMenu') {
      if ($body.hasClass('hidden-menu')) {
        this.asideWidth = $('aside').css('width');
      }
      else{
        $('aside').css('width', this.asideWidth);
      }
    }

    $('aside').children("nav").children("ul").children("li").children("a").children("span").toggleClass('menu-item-submenu', !state.menuOnTop);

    if (state.menuMinified && !state.menuOnTop && !state.mobileViewActivated) {
       $body.addClass('minified');
       $body.removeClass('hidden-menu');
       $body.removeClass('hidden-menu-mobile-lock');

       this.asideWidth = $('aside').css('width');
       $('aside').css('width', '');
    } else if (eventName === 'onMinifyMenu') {
       $('aside').css('width', this.asideWidth);
    }

    $('aside').resize();
    // setTimeout(() => {
    //   $('aside').resize();
    // }, 200);
  }
}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/layout.service.ts